export function getTenantName(): string {
  const { hostname } = globalThis.location;
  if (hostname.includes('localhost')) { return 'local'; }
  return hostname.split('.cockpit.')[0];
}

export function getTenantBackendUrl(): string {
  const tenantName = getTenantName();
  if (tenantName === 'local') {
    return import.meta.env.VITE_LOCAL_BACKEND_ENDPOINT;
  }
  return `https://${tenantName}.cockpit-backend.intellivend.app/api`;
}
